// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__2dZKe","column":"style_column__2vUxy"};